export function isNativeMobileRuntime() {
  if (typeof window === 'undefined') return false;

  if (window.Capacitor || window.ReactNativeWebView || window.Ionic?.WebView) {
    return true;
  }

  const protocol = window.location?.protocol || '';
  if (protocol === 'capacitor:' || protocol === 'ionic:' || protocol === 'file:') {
    return true;
  }

  const userAgent = window.navigator?.userAgent || '';
  return /\bwv\b/i.test(userAgent) || (/Android/i.test(userAgent) && /Version\/[\d.]+/i.test(userAgent));
}